<div *ngIf="!Loaded" class="action-co-body">
  <div class="row w-100 justify-content-center q-nodata q-c-main ">
    <h3>
      <i class="fas fa-file mr-1"></i>
      <label class="big-title">Création de la lettre de mission</label>
    </h3>
  </div>
  <div class="row w-100 justify-content-center q-nodata q-c-main"><i class="fas fa-exclamation-circle"></i></div>
  <div class="row w-100 justify-content-center q-nodata q-c-main">Une mission n'a pas encore été créée</div>
</div>


<div *ngIf="Loaded" class="action-co-body">


  <ng-container *ngIf="!modeBo; else BoContainer">
    <div class="row w-100 mb-3">
      <div class="col-auto" style="font-size: 1rem;">
        <div class="row no-gutters align-items-center">
          <button class="q-btn q-main mr-2" (click)="GenererLDM()" title=""
                  [disabled]="ModelLDM.LDM.DevisSigne || ModelLDM.LDM.DevisPerdu || ModelLDM.LDM.ReadOnly || !ModelLDM?.LDM?.TypeDoc?.id">
            <i class="fas fa-save ml-2"></i>
            <span class="ml-1 mr-2">Générer</span>
          </button>

          <div class="rounded-button q-dark-secondary ml-1 q-pointer"
               [ngbPopover]="PopupTypeDoc"
               placement="bottom"
               [autoClose]="'outside'"
               #pPopupTypeDoc="ngbPopover">
            <i class="fas fa-file-alt mr-1"></i>
            Type Doc :  {{ModelLDM.LDM?.TypeDoc?.id ? ModelLDM.LDM?.TypeDoc?.value :  '------'}}
          </div>
          <ng-template #PopupTypeDoc>
            <ng-container *ngFor="let typeDoc of ModelLDM.Contexte.ListTypeDoc; let i = index">
              <div class="select-type q-pointer px-2" (click)="SelectChange(typeDoc,'TYPEDOC')">{{typeDoc.value}}</div>
            </ng-container>
          </ng-template>

        </div>

      </div>
      <div class="col-auto ml-auto">
        <div class="row">
          <button [disabled]="!ModelLDM.LDM.Ident  || ModelLDM.LDM.Ident  == '0'" class="btn-icon q-c-light-secondary" (click)="OnOpenBo()" title="Afficher le détail de la lettre de mission"><span class="mr-1 q-text-s">lettre de mission</span><i class="fas fa-edit"></i></button>
        </div>
      </div>
    </div>
    <div class="row w-100 mb-3">

      <div *ngFor="let mission of ModelLDM.ListMission" class="col-md-2">
        <div class="mission">
          <div class="q-c-main">{{mission.Type}}</div>
          <!--<div>{{mission.Info}}</div>-->
          <div>
            <button [disabled]="!mission.Ident  || mission.Ident  == '0'" class="btn-icon q-c-light-secondary ml-auto" (click)="OnOpenBoMission(mission)" title="Afficher le détail de la mission">
              <span class="mr-1 q-text-s">{{mission.Info}}</span>
              <i class="fas fa-edit"></i>
            </button>
          </div>
          <div class="q-c-light-black mission_millesime">
            <div>Millesime {{mission.Millesime}}</div>
            <div>{{mission.Montant|money}}</div>
          </div>
        </div>
      </div>

    </div>
    <div class="row w-100 mb-2">

      <div class="col-md-8">
        <div class=" field-select px-3">



          <div class="row h1 justify-content-center align-items-baseline" *ngIf="ModelLDM.LDM.DevisSigne">
            <i class="fas fa-signature q-c-success mr-2"></i><div class="q-c-success">Signé</div> <div class="ml-2 h4">le {{BuildDate(ModelLDM.LDM.DateSignature)}}</div>
          </div>
          <div class="row h1 justify-content-center align-items-baseline" *ngIf="ModelLDM.LDM.DevisPerdu">
            <i class="far fa-thumbs-down q-c-danger mr-2"></i><div class="q-c-danger">Perdu</div> <div class="ml-2 h4">le {{BuildDate(ModelLDM.LDM.DatePerdu)}}</div>
          </div>




          <div class="row align-items-end">
            <div class="col-5">
              <div *ngIf="ModelLDM.LDM.Ident && ModelLDM.LDM.Ident !== '0'" class="row no-gutters align-items-baseline">
                <strong class="q-c-main mr-2">LDM n°{{ModelLDM.LDM.NumeroDoc}}</strong><small>du {{ModelLDM.LDM.DateDoc}}</small>
              </div>
            </div>

            <div *ngIf="ModelLDM.LDM.Ident && ModelLDM.LDM.Ident !== '0' && !ModelLDM.LDM.FileExist" class="col-6 p-0 q-nodata q-c-main">
              <i class="fas fa-exclamation-circle" style="align-self: center;"></i>
              Lettre de mission non générée
            </div>

            <div class="col-auto ml-auto">
              <button *ngIf="ModelLDM.LDM.Ident && ModelLDM.LDM.Ident !== '0' && ModelLDM.LDM.FileExist" [disabled]="!ModelLDM.LDM.Ident || ModelLDM.LDM.Ident == '0'" type="button" class="q-btn-border q-main ml-2" (click)="DownloadDevis('docx')" title="Télécharger le devis au format DOCX"><i class="far fa-file-word"></i></button>
              <button *ngIf="ModelLDM.LDM.Ident && ModelLDM.LDM.Ident !== '0' && ModelLDM.LDM.FileExist" [disabled]="!ModelLDM.LDM.Ident || ModelLDM.LDM.Ident == '0'" type="button" class="q-btn-border q-main ml-2" (click)="DownloadDevis('pdf')" title="Télécharger le devis au format PDF"><i class="far fa-file-pdf"></i></button>
              <button [disabled]="!ModelLDM.LDM.Ident  || ModelLDM.LDM.Ident  == '0'" type="button" class="q-btn-border q-main ml-2" (click)="openUploadDocument(ModalUploadDocument)" title="Transférer le devis modifié"><i class="fas fa-download"></i></button>
            </div>
          </div>

          <div class="row">
            <div class="col-8">
              <div class="row no-gutters">

                <div class="col-12 mb-2">
                  <div class="q-c-light-black q-bold font-size-13">Titre</div>
                  <input type="text" class="q-input-no-border w-100" [(ngModel)]="ModelLDM.LDM.Titre" />
                </div>

                <div class="col-12 mb-2">
                  <div class="q-c-light-black q-bold font-size-13">Info</div>
                  <input type="text" class="q-input-no-border w-100" [(ngModel)]="ModelLDM.LDM.Info" />
                </div>

                <div class="col-12 mb-2">
                  <div class="q-c-light-black q-bold font-size-13">Commentaire</div>
                  <input type="text" class="q-input-no-border w-100" [(ngModel)]="ModelLDM.LDM.Commentaire" />
                </div>

                <div class="col-12 mb-2">
                  <div class="q-c-light-black q-bold font-size-13">Dossier</div>
                  <select class="q-main-select w-100" (change)="SelectChange($event.target.value,'DOSSIER')">
                    <option *ngFor="let dossier of ModelLDM.Contexte?.ListDossierPermanent" value="dossier.id" [selected]="ModelLDM.LDM.Dossier == dossier.id">{{dossier.value}}</option>
                  </select>
                </div>
              </div>


            </div>
            <div class="col-4">
              <div class="row no-gutters">
                <div class="col-12 mb-2">
                  <div class="q-c-light-black q-bold font-size-13">Montant HT avant remise</div>
                  <input type="text" class="q-input-no-border w-100" [(ngModel)]="ModelLDM.LDM.MontantAvantRemise" />
                </div>

                <div class="col-12 mb-2">
                  <div class="q-c-light-black q-bold font-size-13">Remise</div>
                  <input type="text" class="q-input-no-border w-100" [(ngModel)]="ModelLDM.LDM.Remise" />
                </div>

                <div class="col-12 mb-2">
                  <div class="q-c-light-black q-bold font-size-13">Total</div>
                  <input type="text" class="q-input-no-border w-100" [(ngModel)]="ModelLDM.LDM.Montant" />
                </div>
              </div>
            </div>

          </div>




        </div>
      </div>
      <div class="col-md-4">

        <div class=" field-select px-3">
          <div class="row mb-2">
            <strong class="ml-1 q-c-main">
              Personne morale :
            </strong>
            <span class="q-bold">{{actionCoService.Model.Customer.SocialReason}}</span>
          </div>


          <!--   add Contact principal-->
          <div class="col-12 pl-0 mt-2 mb-1">
            <button type="button" class="q-btn-border q-main fixeBtnFont" title="Ajouter des contacts principaux" [ngbPopover]="popCntPrincipalContent" [popoverTitle]="popCntPrincipalTitle" placement="bottom" popoverClass="q-popover" [autoClose]="'outside'">
              <span class="pl-1">Contacts principaux</span>
              <i class="fas fa-plus float-right p-1"></i>
            </button>
          </div>
          <!-- list Contact principal-->
          <div *ngIf="ModelLDM?.Contexte && CheckListCnt(ModelLDM.Contexte.ListContactPrincipal)" class="col-12 py-1 px-3 q-zone-participant">
            <ng-container *ngFor="let cnt of ModelLDM.Contexte.ListContactPrincipal">
              <ng-container *ngIf="cnt.selected">
                <div class="row q-line-user px-2">
                  <!--[ngClass]="{'disabled':DisableBntCnt}"-->
                  <span>{{cnt.value}}</span>
                  <span class="fa-stack fa-xs q-c-danger q-btn-partdelete float-right ml-auto" title="retirer le collaborateur" (click)="RemoveCnt(cnt)">
                    <i class="fas fa-circle fa-stack-2x"></i>
                    <i class="fas fa-trash-alt fa-stack-1x fa-inverse" title="Retirer {{cnt.value}}"></i>
                  </span>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>


      </div>
    </div>

  </ng-container>
</div>


<!-- Detail du devis, du projet, liste des stages Inter Session -->
<ng-template #BoContainer>
  <q-action-co-bo *ngIf="modeBo !== 'MISSION'"  [mode]="modeBo" [idDonneePere]="ModelLDM.Contexte.Client.Id" [idDonneeFils]="ModelLDM.LDM.Ident"  (close)="OnCloseBo($event)"></q-action-co-bo>
  <q-action-co-bo *ngIf="modeBo === 'MISSION'" [mode]="modeBo" [idDonneePere]="ModelLDM.Contexte.Client.Id" [idDonneeFils]="idMission" [idRelation]="relationMission" (close)="OnCloseBo($event)"></q-action-co-bo>
</ng-template>

<ng-template #popCntPrincipalTitle>Choisir les contacts principaux</ng-template>
<ng-template #popCntPrincipalContent>
  <ng-container *ngIf="ModelLDM?.Contexte && CheckListCnt(ModelLDM.Contexte.ListContactPrincipal,false)">
    <div class="p-2">
      <ng-container *ngFor="let cnt of ModelLDM.Contexte.ListContactPrincipal">
        <ng-container *ngIf="!cnt.selected">
          <div class="q-line-adduser" (click)="AddCnt(cnt)">
            <span class="ml-2">{{cnt.value}}</span>
            <span class="fa-stack fa-xs float-right mr-2 q-c-main q-btn-addpart">
              <i class="fas fa-circle fa-stack-2x d-none"></i>
              <i class="fas fa-plus fa-stack-1x fa-inverse d-none" title="Ajouter {{cnt.value}}"></i>
            </span>
          </div>
          <hr class="m-0" />
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
  <ng-container *ngIf="!CheckListCnt(ModelLDM.Contexte.ListContactPrincipal,false)">
    Aucun contact à ajouter
  </ng-container>
</ng-template>



<!-- Upload du devis -->
<ng-template #ModalUploadDocument let-modalUploadDocument>
  <div class="modal-header">
    <h5 class="modal-title" id="uploadDocumentModalLongTitle"></h5>
    <button type="button" class="close" aria-label="Close" (click)="modalUploadDocument.close('CANCEL')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <q-insertdoc class="h-100 w-100" boHidden [item]="insertDocModel" [registerMode]="'UPLOADDOCWOLINK'" (success)="modalUploadDocument.close('SAVE')"></q-insertdoc>
  </div>
</ng-template>
